import React from 'react'

export function NotFound() {
	return <>
		<div className='d-flex w-100 vh-75 align-items-center justify-content-center '>
			
			<h2 className='text-danger display-1'> 404 Not Found</h2>


		</div>
	</>
}